import { useInfiniteQuery } from "react-query";
import { getProjectActivityFeed } from "../../services/api/activityFeed/activityFeedApi";

export const useProjectActivityFeed = (projectId, limit = 20) => {
  const query = useInfiniteQuery(
    ["projectActivityFeed", projectId],
    ({ pageParam }) => getProjectActivityFeed(projectId, pageParam, limit),
    {
      enabled: !!projectId,
      staleTime: 30000,
      retry: 1,
      getNextPageParam: (lastPage) => {
        if (lastPage.hasMore && lastPage.nextCursor) {
          return lastPage.nextCursor;
        }
        return undefined;
      },
    }
  );

  const allItems = query.data?.pages?.flatMap((page) => page.items) ?? [];

  return {
    items: allItems,
    isLoading: query.isLoading,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    refetch: query.refetch,
    error: query.error,
  };
};
